import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useRecoilState, useRecoilValue } from "recoil"
import {
  sizeState,
  themeState,
  userObjState,
  pagesNprofileState,
  updatedPagesObjState,
  updatedProfileObjState,
} from "../recoil-atom"

import { authService, dbService } from "../fbase"
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  GithubAuthProvider,
  signInWithPopup,
} from "firebase/auth"
import { doc, setDoc, getDoc } from "firebase/firestore"

import {
  Flex,
  FlexColumn,
  Input,
  DivRound,
} from "../styled-components-openmark"
// import styled from "styled-components"

import {
  linkPage0Group0,
  linkPage0Group1,
  linkPage0Group2,
  linkPage0Group3,
  linkPage1Group0,
  linkPage1Group1,
  linkPage1Group2,
  linkPage1Group3,
} from "../initdata-user"

////
//
const addNewUser = async (data) => {
  const now = new Date().getTime()

  // Add Page
  const newPagesObj = {}

  const newPage0 = {
    title: null,
    description: null,
    createdAt: now,
    updatedAt: now,
    groupOrder: ["group0", "group1", "group2", "group3"],
    group0: linkPage0Group0,
    group1: linkPage0Group1,
    group2: linkPage0Group2,
    group3: linkPage0Group3,
  }

  const newPage1 = {
    title: null,
    description: null,
    createdAt: now,
    updatedAt: now,
    groupOrder: ["group0", "group1", "group2", "group3"],
    group0: linkPage1Group0,
    group1: linkPage1Group1,
    group2: linkPage1Group2,
    group3: linkPage1Group3,
  }

  const newPage2 = {
    title: null,
    description: null,
    createdAt: now,
    updatedAt: now,
    groupOrder: ["group0", "group1", "group2", "group3"],
    group0: [],
    group1: [],
    group2: [],
    group3: [],
  }

  const newPage3 = {
    title: null,
    description: null,
    createdAt: now,
    updatedAt: now,
    groupOrder: ["group0", "group1", "group2", "group3"],
    group0: [],
    group1: [],
    group2: [],
    group3: [],
  }

  // Add User
  const newUserObj = {
    uid: data.user.uid,
    email: data.user.email,
    displayName: `${
      data.user.displayName
        ? data.user.displayName
        : data.user.email.split("@")[0]
    }`,
    info: null,
    search: "naver",
    colors: {
      b0: "#eee",
      b1: "#ccc",
      b2: "#aaa",
      f2: "#555",
      f1: "#333",
      f0: "#111",
    },
    pageOrder: ["page0", "page1", "page2", "page3"],
    page0: newPage0,
    page1: newPage1,
    page2: newPage2,
    page3: newPage3,
    memos: [],
    lastLoginAt: now,
    createdAt: now,
    updatedAt: now,
  }
  const docUserRef = doc(dbService, "users", data.user.uid)
  await setDoc(docUserRef, newUserObj)

  return newUserObj
}

////
//
const getUser = async (data) => {
  // Get User
  const docUserRef = doc(dbService, "users", data.user.uid)
  const docUserSnap = await getDoc(docUserRef)
  const newUserObj = docUserSnap.data()

  return newUserObj
}

//////
////
//
const Auth = ({ refreshUser }) => {
  const navigate = useNavigate()
  const [theme, setTheme] = useRecoilState(themeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const { pagesObj, profileObj, shortName } = useRecoilValue(pagesNprofileState)
  const [updatedPagesObj, setUpdatedPagesObj] =
    useRecoilState(updatedPagesObjState)
  const [updatedProfileObj, setUpdatedProfileObj] = useRecoilState(
    updatedProfileObjState
  )

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")

  const onChange = (event) => {
    const {
      target: { name, value },
    } = event

    if (name === "email") {
      setEmail(value)
    } else if (name === "password") {
      setPassword(value)
    }
  }

  const onSignIn = async (event) => {
    let data
    try {
      data = await signInWithEmailAndPassword(authService, email, password)

      const newUserObj = await getUser(data)
      setUserObj(newUserObj)
      window.localStorage.setItem("user", JSON.stringify(newUserObj))
      setUpdatedPagesObj(pagesObj)
      setUpdatedProfileObj(profileObj)

      navigate("/")
    } catch (error) {
      console.log(error.message)
      if (error.message === "Firebase: Error (auth/invalid-email).") {
        alert("잘못 입력하셨습니다")
      }
      if (error.message === "Firebase: Error (auth/user-not-found).") {
        alert("등록된 사용자가 아닙니다. Sign Up 부탁드립니다.")
      }
      if (error.message === "Firebase: Error (auth/wrong-password).") {
        alert("비밀번호가 틀력습니다")
      }
    }
    // console.log("SignIn", email, password, data)
  }
  const onSignUp = async (event) => {
    let data
    try {
      data = await createUserWithEmailAndPassword(authService, email, password)

      const newUserObj = await addNewUser(data)
      setUserObj(newUserObj)
      window.localStorage.setItem("user", JSON.stringify(newUserObj))
      setUpdatedPagesObj(pagesObj)
      setUpdatedProfileObj(profileObj)

      navigate("/")
    } catch (error) {
      console.log(error.message)
      if (error.message === "Firebase: Error (auth/invalid-email).") {
        alert("잘못 입력하셨습니다")
      }
      if (error.message === "Firebase: Error (auth/email-already-in-use).") {
        alert("이미 가입하셨습니다")
      }
    }
  }

  const onEnterPress = (event) => {
    if (event.key === "Enter") onSignIn()
  }

  const onSocialClick = async (event) => {
    const now = new Date()

    const {
      target: { name },
    } = event
    let provider
    if (name === "google") {
      provider = new GoogleAuthProvider()
    } else if (name === "github") {
      provider = new GithubAuthProvider()
    }
    const data = await signInWithPopup(authService, provider)

    let newUserObj
    if (data.user.metadata.lastLoginAt - data.user.metadata.createdAt < 100) {
      newUserObj = await addNewUser(data)
    } else {
      newUserObj = await getUser(data)
    }

    setUserObj(newUserObj)
    window.localStorage.setItem("user", JSON.stringify(newUserObj))
    setUpdatedPagesObj(pagesObj)
    setUpdatedProfileObj(profileObj)

    navigate("/")
  }

  //////
  ////
  //
  return (
    <Flex center>
      <div className="auth">
        <Flex center style={{ margin: "30px 0" }}>
          <div className="init-logo"></div>
          <span style={{ fontSize: "40px", fontWeight: 700 }}>
            openmark
            {/* <span style={{ backgroundColor: "black", color: "white" }}>
              MARK
            </span> */}
          </span>
        </Flex>
        <DivRound
          style={{ paddingBottom: "20px", boxShadow: "1px 1px 6px -1px #ccc" }}
        >
          <form>
            <div className="auth_email">
              <FlexColumn>
                <Input
                  style={{
                    margin: "5px 0 5px 5px",
                    width: "220px",
                    height: "45px",
                  }}
                  name="email"
                  type="text"
                  placeholder="Email"
                  required
                  value={email}
                  onChange={onChange}
                />
                <Input
                  style={{
                    margin: "5px 0 5px 5px",
                    width: "220px",
                    height: "45px",
                  }}
                  name="password"
                  type="password"
                  placeholder="Password"
                  required
                  value={password}
                  onChange={onChange}
                  onKeyPress={onEnterPress}
                />
              </FlexColumn>
              <FlexColumn>
                <DivRound
                  button
                  onClick={onSignIn}
                  width={80}
                  bgColor={theme.f1}
                  color={theme.b0}
                  style={{
                    textAlign: "center",
                    boxShadow: "1px 1px 6px -1px #333",
                  }}
                >
                  Sign In
                </DivRound>
                <DivRound
                  button
                  onClick={onSignUp}
                  width={80}
                  bgColor={theme.b2}
                  color={theme.f2}
                  style={{ textAlign: "center" }}
                >
                  Sign Up
                </DivRound>
              </FlexColumn>
            </div>
          </form>
          <div style={{ textAlign: "center" }}>
            <button
              className="round"
              onClick={onSocialClick}
              name="google"
              width={300}
              bgColor={theme.f1}
              color={theme.b0}
              boxShadow={"1px 1px 6px -1px #777"}
            >
              Google로 로그인
            </button>
          </div>
          {/* <button
            className="round"
            onClick={onSocialClick}
            name="github"
            bgColor={"#444"}
            color={"#ddd"}
            boxShadow={"1px 1px 6px -1px #bbb"}
          >
            Continue with Github
          </button> */}
        </DivRound>
        <DivRound
          bgColor={theme.b0}
          style={{ padding: "20px 0", border: "solid 1px #aaa" }}
        >
          <div style={{ textAlign: "start", margin: "0 20px 10px 20px" }}>
            openmark에서 다양한 환경에서 자기만의 동일한 인터넷 시작 환경을
            만드세요.
          </div>
          {/* <Link to="/sample">
            <DivRound
              bgColor={theme.f2}
              color={theme.b0}
              width={300}
              style={{ textAlign: "center" }}
            >
              예제 페이지 보기
            </DivRound>
          </Link> */}
          <Flex center width="300px">
            <img src="/imgs/openmark6.png" width="240px" />
          </Flex>
          <Link to="/usage">
            <DivRound
              bgColor={theme.f2}
              color={theme.b0}
              width={300}
              style={{ textAlign: "center" }}
            >
              사용안내
            </DivRound>
          </Link>
        </DivRound>
      </div>

      <style jsx>{`
        .init-logo {
          width: 64px;
          height: 64px;
          background-image: url("/logoA.png");
          background-size: cover;
          background-position: center center;
        }
        .auth {
          width: 360px;
        }
        .auth_email {
          padding: 10px 0;
          width: 360px;
          display: grid;
          grid-template-columns: 1fr 100px;
          // grid-template:
          //   "email sign" 50px
          //   "password sign" 50px
          //   / 1fr 100px;
        }
        .round {
          cursor: pointer;
          width: 300px;
          margin: 10px auto 0 auto;
          border: none;
          border-radius: 20px;
          padding: 10px 0;
          box-shadow: 1px 1px 6px -1px #bbb;
          background-color: ${theme.f1};
          color: ${theme.b0};
          font-size: 18px;
        }
      `}</style>
    </Flex>
  )
}

export default Auth
